"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _colors = _interopRequireDefault(require("../../colors"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var INIDICATOR_POSITIONS = {
  'sm': {
    height: 6,
    width: 6,
    bottom: '1%',
    right: '1%'
  },
  'md': {
    height: 8,
    width: 8,
    bottom: '1%',
    right: '1%'
  },
  'lg': {
    height: 10,
    width: 10,
    bottom: '2%',
    right: '2%'
  },
  'xl': {
    height: 10,
    width: 10,
    bottom: '2%',
    right: '2%'
  }
};

var AvatarStatus = function AvatarStatus(_ref) {
  var status = _ref.status,
      avatarSize = _ref.avatarSize;

  if (!status) {
    return null;
  }

  var getStatusColor = function getStatusColor(statusType) {
    switch (statusType) {
      case 'online':
        return _colors["default"].success;

      case 'busy':
        return _colors["default"].danger;

      case 'offline':
        return _colors["default"].raven;

      default:
        return _colors["default"].raven;
    }
  };

  var inidicatorPositioning = INIDICATOR_POSITIONS[avatarSize];
  return _react["default"].createElement("span", {
    style: _objectSpread({
      position: 'absolute',
      borderRadius: '100%',
      backgroundColor: getStatusColor(status),
      border: '2px solid #FFFFFF'
    }, inidicatorPositioning)
  });
};

AvatarStatus.propTypes = {
  status: _propTypes["default"].oneOf(['online', 'busy', 'offline'])
};
var _default = AvatarStatus;
exports["default"] = _default;